export default "__VITE_ASSET__DOmV$vx9__"